const events = require('../core/events');
const forgeUiComponent = require('../framework/ui-component');

const PodcastSubscribe = forgeUiComponent('PodcastSubscribe', {
  subscribing: 'is-subscribing'
}, function PodcastInfoConstructor() {
  const self = this;
  const subscribeButton = this.element.querySelector('.PodcastSubscribe-button') || document.createElement('div');

  this.element.addEventListener(events.uiModalDismiss, function () {
    self.subscribing = false;
  });

  subscribeButton.addEventListener('click', function openSubscribeDialog(e) {
    e.preventDefault();
    self.subscribing = true;
  });
});

module.exports = PodcastSubscribe;



//////////////////
// WEBPACK FOOTER
// ./src/js/ui/podcast-subscribe.js
// module id = 77
// module chunks = 0